/**
 * Klaviyo Back in Stock: POSTs "notify me" subscriptions to Klaviyo.
 * Requires theme settings: Klaviyo > Enable Back in Stock + public API key.
 * Variant id format: {@code $shopify:::$default:::VARIANT_ID}
 */
(function () {
  'use strict';

  var formSelector = '[data-notification-form]';
  var revision = '2024-06-15';

  /**
   * @returns {null | { companyId: string }}
   */
  function getConfig() {
    var v = window.klaviyoVariables;
    if (!v || !v.back_in_stock_enabled || !v.company_id) return null;
    return { companyId: String(v.company_id).trim() };
  }

  /**
   * @returns {string}
   */
  function getEndpointBase() {
    var v = window.klaviyoVariables;
    var base = (v && v.api_url) || 'https://a.klaviyo.com';
    return String(base).replace(/\/$/, '');
  }

  /**
   * @param {HTMLFormElement} form
   * @returns {{ email: string, variantId: string }}
   */
  function getFormData(form) {
    var emailInput =
      form.querySelector('input[name="contact[email]"]') || form.querySelector('#NotificaitonFormEmail');
    var email = emailInput ? String(emailInput.value || '').trim() : '';
    var variantId = form.getAttribute('data-variant-id') || '';
    return { email: email, variantId: String(variantId).trim() };
  }

  /**
   * @param {HTMLFormElement} form
   */
  function showSuccess(form) {
    var container = form.closest('product-notification');
    if (!container) return;
    var heading = container.querySelector('[data-product-notification-heading]');
    var successEl = form.querySelector('[data-klaviyo-bis-success]');
    var fieldsEl = form.querySelector('[data-notification-form-fields]');
    var popup = container.closest('popup-component') || container.closest('.product-modal');
    if (heading) heading.classList.add('hidden');
    if (successEl) successEl.style.display = '';
    if (fieldsEl) fieldsEl.style.display = 'none';
    if (popup) popup.classList.add('has-success');
  }

  /**
   * @param {HTMLFormElement} form
   * @param {string} message
   */
  function showError(form, message) {
    var fieldsEl = form.querySelector('[data-notification-form-fields]');
    if (!fieldsEl) return;
    var err = fieldsEl.querySelector('.product__notification__error');
    if (!err) {
      err = document.createElement('p');
      err.className = 'product__notification__error';
      err.setAttribute('role', 'alert');
      fieldsEl.insertBefore(err, fieldsEl.firstChild);
    }
    err.textContent = message;
    err.hidden = false;
  }

  /**
   * @param {HTMLFormElement} form
   * @param {boolean} loading
   */
  function setButtonLoading(form, loading) {
    var btn = form.querySelector('button[type="submit"]');
    if (!btn) return;
    var span = btn.querySelector('span');
    var strings = window.klaviyoBisStrings || {};
    if (loading) {
      btn.disabled = true;
      if (span) span.textContent = strings.submitting || '…';
    } else {
      btn.disabled = false;
      if (span) {
        span.textContent = btn.getAttribute('data-klaviyo-bis-original-text') || span.textContent;
      }
    }
  }

  /**
   * @param {{ companyId: string }} config
   * @param {{ email: string, variantId: string }} data
   * @param {function (Error | null): void} done
   */
  function subscribeBackInStock(config, data, done) {
    if (!data.variantId) {
      done(new Error('Missing variant id'));
      return;
    }
    var variantCompositeId = '$shopify:::$default:::' + data.variantId;
    var url =
      getEndpointBase() +
      '/client/back-in-stock-subscriptions/?company_id=' +
      encodeURIComponent(config.companyId);
    var body = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: data.email
              }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: variantCompositeId
            }
          }
        }
      }
    };

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        revision: revision
      },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (res.status === 202 || res.ok) return done(null);
        return res
          .json()
          .then(function (json) {
            return done(
              new Error(json.errors && json.errors[0] ? json.errors[0].detail : String(res.status))
            );
          })
          .catch(function () {
            return done(new Error(String(res.status)));
          });
      })
      .catch(function (err) {
        return done(err);
      });
  }

  /**
   * @param {SubmitEvent} ev
   */
  function handleSubmit(ev) {
    var config = getConfig();
    if (!config) return;

    var form = ev.target;
    if (!form || !form.matches(formSelector)) return;

    ev.preventDefault();
    ev.stopImmediatePropagation();

    var data = getFormData(form);
    if (!data.email) {
      var strings = window.klaviyoBisStrings || {};
      showError(form, strings.error || (window.notifyMe && window.notifyMe.error) || 'Error');
      return;
    }

    var btn = form.querySelector('button[type="submit"]');
    var span = btn && btn.querySelector('span');
    if (btn && span) btn.setAttribute('data-klaviyo-bis-original-text', span.textContent);
    setButtonLoading(form, true);
    var errEl = form.querySelector('.product__notification__error');
    if (errEl) errEl.hidden = true;

    subscribeBackInStock(config, data, function (err) {
      setButtonLoading(form, false);
      if (err) {
        var str = window.klaviyoBisStrings || {};
        showError(form, str.error || (window.notifyMe && window.notifyMe.error) || 'Error');
        return;
      }
      showSuccess(form);
    });
  }

  function init() {
    if (!getConfig()) return;
    document.addEventListener('submit', handleSubmit, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
